<div class="w-100 col">
	<div class="col w-100 mb-2 p-1">
		<div class="row">
			<my-col-input [tabindex]="tabindex" [mask]="'c2'" #Cabeza [extraClass]="'hacienda-input'" class="hacienda-input" [parent]="parent" [labelName]="'Por Cabeza'" [required]="required" [allowCero]="!required"></my-col-input>
			<my-col-input [tabindex]="tabindex + 1" [mask]="'c2'" #Kilo [extraClass]="'hacienda-input'" class="hacienda-input" [parent]="parent" [labelName]="'Por Kilo'" [required]="required" [allowCero]="!required"></my-col-input>
			<my-col-input [tabindex]="tabindex + 2" [mask]="'c2'" #Total [extraClass]="'hacienda-input'" class="hacienda-input" [parent]="parent" [labelName]="'Total'" [required]="required" [allowCero]="!required"></my-col-input>
		</div>
	</div>
</div>
